
import PopupPicker from 'vux/src/components/popup-picker/index.vue'
import Group from 'vux/src/components/group/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Alert from 'vux/src/components/alert/index.vue'
import Confirm from 'vux/src/components/confirm/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'

import global from '../../../static/js/global.js'
import loadPage from '../../components/loadingPage'
import $ from 'jquery'
import XInput from "vux/src/components/x-input/index";
import { log } from 'util';
export default {

components: {
XInput,
PopupPicker,
Group,
XButton,
Flexbox,
FlexboxItem,
Alert,
Confirm,
loadPage,
$,
Datetime
},
data(){
return{
classLi:'am_ulistLiFS',
show_5:false, // 如果有车位信息 就是false 没有 就是true
cont: true, // 主界面
PLSJfs:'一个月',
title1:'车位缴费',//缴费名称
jfYs: [['1个月', '2个月', '3个月', '4个月', '5个月', '6个月', '7个月','8个月','9个月','10个月','11个月','12个月','13个月','14个月','15个月','16个月','17个月','18个月','19个月','20个月','21个月','22个月','23个月','24个月']],
value_1:[],  // 车位信息集合
value_Q:[],
list_1: [[]], // 车位信息
valueTime:'2012/12/12',//续费至时间
endDates:'',
myDilogs:'',
nextEndDates:'', // 续费至 年 + 月 + 日
selectDate:[[],[],[]],//初始化时间选择
phone:'',//电话
mycarList:[],//绑定车辆集合
mycarListInfo:[],//缴费明细集合
myTime:[],// 缴费月份集合 1-3-12-6+1-12+1
baseRate:'',//基础量
dailogMessage:'',
comnCode:'',
submitable:false,
mousth:'',
show:false,
comnList:'',
showLog:false,
mssl:[], // 车牌号集合 页面初始化
msrue1:false,
msrue:false,
feeShow:false,
show_1:false,
feeBillList:[],

sMonth:'',
sQx:'',
pkUs:'',
feeMoey:'',
sDate:'',  // 到期时间
qsType:'',   // 权属类型
useXz:'',   // 车位使用性质 1购买 2租赁
sumMoney:'',  // 车位单价
totalFeeMoney:'0.0',
prevValueTime:'',

pkId:'',  // 车位主键
disTypes:'', // 优惠赠送字段 业务上没什么用
billCode:'',
dayms:'',
mVals:'',
qYleix:'',
qYq:'',
youH:'', // 优惠金额
shiS:'',// 实收金额
riQYF:'',
jlJf:'', // 下拉选择缴费月份的值
yhYFF:'',
mousss:[],
dateJy:'',
oneName: "",
}
},
beforeMount(){
this.show_1 = true;
setTimeout(function() {
this.show_1 = false;
}, 1000);
this.getInitSelectDate();


let url2=global.host+'discountConfig/getListByPark?comnCode='+this.$router.history.current.query.comnCode;
this.$http.get(url2).then(function(res){
this.show_1 = false;
let tiems = res.body.result;
this.myTime = new Object();
for(let jm in tiems){
this.myTime[jm] = tiems[jm];
}
this.loadAjax();
console.log(this.myTime);
try{
this.disTypes = this.myTime[0].discType;  
}catch (e) {}

this.show_1 = false;
},function(err){
this.show_1 = false;
console.log(err)
})

},
mounted(){










if(this.$router.history.current.path == '/carPaycoment'){
document.title = "车辆缴费";
}

$(".am_font1").parent(".weui-dialog__bd").css({"padding-left":"0.1em","padding-right":"0.1em"})

$(".am_ulist").delegate("li","click",function(){
$(this).find("button").addClass("am_persfors");
$(this).siblings("li").find("button").removeClass("am_persfors");
})
this.msrue = true;
this.msrue1 = false;
},
methods:{
onZDY(){
if(this.$refs.val_jf.currentValue[0].length == '4'){
this.jlJf = this.$refs.val_jf.currentValue[0].substr(0,2);
}else{
this.jlJf = this.$refs.val_jf.currentValue[0].substr(0,1);
}
this.setPayTime(this.jlJf,0);

$(".am_ulist").find("button").removeClass("am_persfors");


},

async loadAjax(){
let url1=global.host+'parkinginfo/queryParkInfo?phone='+this.$router.history.current.query.phone+'&comnCode='+this.$router.history.current.query.comnCode
await this.$http.get(url1).then(function(res){
console.log('所有信息')
console.log(res)
let reslt = res.body.result; 
if(reslt.length == 0){

this.show_5 = true;
this.cont = false;

}else if(reslt.length != 0){

this.show_5 = false;
this.cont = true;
}
let slit = [];
let mdata = "";
this.comnList = res.body.result; 
if(res.status==200){
for(var i = 0 ; i < reslt.length; i++){
this.list_1[0].push(reslt[i].park.parkingInfo.pkCode);
this.value_1[0] = this.list_1[0][0]
}
this.onChange(this.list_1[0][0]);

for(let its in reslt){
try {
for(let mitem in reslt[its].car){
mdata = reslt[its].car[mitem].pkCode;  
this.mssl.push(reslt[its].car[0].carNo); 

}
}catch(e){console.error("未找到车辆信息");}

for(let bm in reslt[its].park){
this.endDates = reslt[its].park.parkingInfo.endDate; 
if(!this.endDates){
this.dailogMessage = '该车位尚未缴纳过费用，请前往物业处确认开始缴费时间!';
this.feeShow = true;
}
try {
this.dateJy = this.dateAdd(this.endDates);
let mdate = this.endDates.split("-");  
this.dayms = parseInt(mdate[2]);  

if(this.dayms < 10){
this.dayms = '0' + this.dayms;
}

let defaultCount = this.myTime[0].baseRate;  
let yyh = this.myTime[0].defaultRate;

this.valueTime = this.subMonths(this.endDates, defaultCount);  

this.nextEndDates = this.valueTime +"-"+this.dayms; 
this.setPayTime(defaultCount,yyh);
$(".am_ulist > li:eq(0)").find("button").addClass("am_persfors"); 
}catch(e){
console.error('$$$$$$$$$$$$$$$$$$$$$$$$');
console.error(e);
}

if(this.list_1[0][0] == mdata){  // 如果车位只有一个
this.sDate = reslt[its].park.parkingInfo.endDate;  
this.qsType = reslt[its].park.feeItem.feeName;   
this.qYleix =  reslt[its].park.parkingInfo.pkFloor;  
this.useXz = reslt[its].park.parkingInfo.pkUsed; 
this.sumMoney = reslt[its].park.feeRate;  
this.pkId = reslt[its].park.parkingInfo.pkId;  

}

}
}





let ms = Array.from(new Set(this.list_1[0]))  
this.list_1[0] = ms;
this.value_1[0] = this.list_1[0][0];  
this.onChange(this.list_1[0][0]);  

this.sMonth = dateFormat(new Date(this.sDate), 'YYYY-MM');
this.sQx = this.qsType;
this.qYq = this.qYleix;
this.feeMoey = this.sumMoney + "元/月";   
this.pkUs = this.useXz;
}

},function(err){
console.log(err)
})
},
mload(){
this.nextEndDates = this.valueTime +"-"+this.dayms;
},
onChange(index){
this.mycarList = []; 
this.sDate = '';
this.endDates = '';
this.dateJy = '';
let carCode = "";
for(let ns in this.comnList){  // 遍历一个车位里的所有车辆
for(let bs in this.comnList[ns].car){  // // 遍历一个车位里的所有车辆 的car项
carCode = this.comnList[ns].car[bs].pkCode;
if(index == carCode){
try {
let carNos = this.comnList[ns].car[bs].carNo;
this.mycarList.push(carNos);
}catch(e){console.error("未找到车辆信息");}
}
}
this.mycarList =  Array.from(new Set(this.mycarList));
if(index == carCode){
this.sDate = this.comnList[ns].park.parkingInfo.endDate;
if(!this.sDate){
this.dailogMessage = '该车位尚未缴纳过费用，请前往物业处确认开始缴费时间!';
this.feeShow = true;
}
this.qsType = this.comnList[ns].park.feeItem.feeName;
this.qYleix = this.comnList[ns].park.parkingInfo.pkFloor;
let pkOwner = this.comnList[ns].park.parkingInfo.pkOwner;
let pkUsed = this.comnList[ns].park.parkingInfo.pkUsed,
useXz;
if(pkOwner=="公共车位"){
if(pkUsed=="0"){
useXz ="已租赁"
}else{
useXz = "未租赁";
}
}else {
if (pkUsed == "0") {
useXz = "已出售";
} else {
useXz = "未出售";
}
}
this.useXz = useXz;
this.sumMoney = this.comnList[ns].park.feeRate;
this.pkId = this.comnList[ns].park.parkingInfo.pkId;
}
}
this.sMonth = dateFormat(new Date(this.sDate), 'YYYY-MM');
this.sQx = this.qsType;
this.qYq = this.qYleix;
this.feeMoey = this.sumMoney + "元/月";
this.pkUs = this.useXz;
this.endDates = this.sDate;
this.valueTime = this.subMonths(this.endDates,'1');  

this.dateJy = this.dateAdd(this.endDates);

this.setToday();
this.setPayTime('1','0')
$(".am_ulist").find("button").removeClass("am_persfors");

},

serchDetail(){
let url2=global.host + 'parkinginfo/getParkTopic'+'?comnCode='+this.$router.history.current.query.comnCode
this.$http.get(url2).then(function(res){
this.mycarListInfo=res.body.result;

},function(err){
console.log(err);
});

this.showLog = true;
},
cancel(){
this.submitable = false;
},

getMonths(date1 , date2){

date1 = date1.split("-");
date2 = date2.split("-");

var year1 = parseInt(date1[0]) ,
month1 = parseInt(date1[1]) ,
year2 = parseInt(date2[0]) ,
month2 = parseInt(date2[1]) ,

months = (year2 - year1) * 12 + (month2-month1);


this.mousth = months+'个月';
return months;
},

subMonths(date , addMonth){

/*let s = $(".vux-datetime").find(".vux-cell-value").text(this.mVals)
console.log(s)*/
addMonth = parseInt(addMonth); 

date = date.split("-");

var year = parseInt(date[0]); 
var month = parseInt(date[1]);  
var riQ =  parseInt(date[2]);  
var sumMonth = parseInt(month+addMonth); 
if(sumMonth%12==0){
var chushu = (sumMonth/12)-1;
year = year + chushu;
month = sumMonth - (12*chushu);
}else if(sumMonth > 12){
var chushu = Math.floor(sumMonth/12);
year = year + chushu;
month = sumMonth - (12*chushu);
}else{
month = sumMonth;
}
if(riQ == 1){  // 如果当前是1号
var dateYar= this.getCurrentMonthLast(year+"-"+(month-1));

this.riQYF = dateYar.substring(dateYar.length-2)
if(month<10){month="0"+month;}
if(this.riQYF<10){this.riQYF="0"+this.riQYF;}
var dates = year+"-"+(parseInt(month)-1)+'-'+this.riQYF;
return this.dateAdd(dates);

}else if(riQ != 1){
this.riQYF = riQ
if(month<10){month="0"+month;}
if(this.riQYF<10){this.riQYF="0"+this.riQYF;}

var dates = year+"-"+month+'-'+(this.riQYF-1);;
return this.dateAdd(dates);
}




},
setPayTime(time,defaultRate){
this.mousss = time + '个月';

let timeNum = parseInt(time); 
this.feeBillList = [];
for(var i =1;i<=timeNum;i++){
let feeObj = new Object();
feeObj.month = this.subMonths(this.endDates , i);
this.feeBillList.push(feeObj);
this.valueTime = feeObj.month;

}
this.nextEndDates = this.valueTime +"-"+this.dayms;  
if(defaultRate == '0'){  // 如果优惠月份等于0的话
this.yhYFF = '0';
this.totalFeeMoney = (this.sumMoney*timeNum).toFixed(2)+'元'; 
this.youH = '00.00元'
this.shiS = this.totalFeeMoney;
}else if(defaultRate != '0'){
this.yhYFF = defaultRate;
this.totalFeeMoney = (this.sumMoney*timeNum).toFixed(2)+'元';
let danJia = this.sumMoney;
let youHys = defaultRate;
this.youH = (this.sumMoney*defaultRate).toFixed(2)+'元';
let aa = (this.sumMoney*timeNum).toFixed(2);
let bb =  (danJia*youHys).toFixed(2);
this.shiS =(aa-bb).toFixed(2)+'元';
}

},
setToday(){
let months = this.getMonths(this.endDates, this.valueTime);

},
/*chanVal(){
$(".vux-datetime").find(".vux-cell-value").text(this.valueTime);
},*/
/*初始化时间选择*/
getInitSelectDate(){
let date = new Date()
date = new Date(date.getFullYear(),date.getMonth() + 1,date.getDate(), 1)
this.selectDate[0].push(date.getFullYear())
this.selectDate[0].push(date.getFullYear() + 1)
let curM = date.getMonth() + 1;
this.selectDate[1] = new Array();
for(let i = curM ; i < 13 ; i++){
this.selectDate[1].push(i);
}

let curD = date.getDate();
this.selectDate[2] = new Array();
for(let n = curD ; n < 31 ; n++){
this.selectDate[2].push(n);
}
},

getCurrentMonthLast (date){
var endDate = new Date(date); 
var month=endDate.getMonth();
var nextMonth=++month;
var nextMonthFirstDay=new Date(endDate.getFullYear(),nextMonth,1);
var oneDay=1000*60*60*24;
var dateString=new Date(nextMonthFirstDay-oneDay);
return dateString.toLocaleDateString(); 
},

dateAdd(startDate) {
startDate = new Date(startDate);
startDate = +startDate + 1000*60*60*24;
startDate = new Date(startDate);
var nextStartDate = startDate.getFullYear()+"-"+(startDate.getMonth()+1)+"-"+startDate.getDate();
var daww = nextStartDate.split('-');
var mouth = daww[1];
var darr  = daww[2];
if(darr < 10){ darr = '0' + darr}
if(mouth < 10){ mouth = '0' + mouth}
var dateRTY = daww[0]+"-"+mouth+"-"+darr;
return dateRTY;
},

submitBefore(kId,feeBz,monthCout){
if(!this.endDates){
this.dailogMessage = '该车位尚未缴纳过费用，请前往物业处确认开始缴费时间!';
this.feeShow = true;
return;
}
if(monthCout.length == '4'){
monthCout = monthCout.substr(0,2)
}else{
monthCout = monthCout.substr(0,1)
}

let yzUrl = global.host + 'parkFeeBill/findownerunpaidorder?phoneNo='
+this.$router.history.current.query.phone+'&comnCode='+this.$router.history.current.query.comnCode
+'&openid='+this.$router.history.current.query.openid;
this.$http.get(yzUrl).then(function(res){
if(res.body.code == '110'){

let usinfo = new Object();

usinfo.comnCode = this.$router.history.current.query.comnCode;
usinfo.startDate = this.dateJy;   
usinfo.endDate = this.valueTime;   
usinfo.pkId = kId;
usinfo.feePrice = feeBz;
usinfo.feeCount = monthCout;
usinfo.discType = this.disTypes;
usinfo.feeMoney = this.totalFeeMoney.split('元')[0];  
usinfo.freeMonth = this.yhYFF;  
usinfo.discMoney = this.youH.split('元')[0];  
if(this.youH == '00.00元'){
usinfo.realMoney = this.totalFeeMoney.split('元')[0];
}else{
usinfo.realMoney = this.shiS.split('元')[0];  
}
usinfo.startDate = this.endDates;
usinfo.openId = this.$router.history.current.query.openid;
usinfo.mainPhone = this.$router.history.current.query.phone;

let urls = global.host + 'parkFeeBill/addParkFeeBill';
this.$http.post(urls,usinfo).then(function(res){
let statuCodes = res.body.statusCode;

if(statuCodes == '110'){
this.billCode = res.body.result.billCode;
this.gopay();

}else if(statuCodes == '120'){
this.feeShow = true;
this.dailogMessage = "提交失败";
}
},function(err){
console.log(err)
})

}else if(res.body.code == '120'){
this.dailogMessage = '您有未处理的订单,请优先处理';
this.feeShow = true;
}
},function(err){
console.log(err)
})

},
/*去支付方法*/
gopay(){
let senddata = new Object();
senddata.comnCode = this.$router.history.current.query.comnCode;
senddata.memberNo = this.$router.history.current.query.phone;
senddata.openid = this.$router.history.current.query.openid;
senddata.tradeAmount = this.shiS.split("元")[0];
senddata.tradeNo = this.billCode;
senddata.tradeName='车位费';
senddata.tradeDesc='车位费';
let url = global.host + 'parkFeeBill/getpayurl';
this.$http.post(url,senddata).then(function(res){
if(res.body.code == '110'){
location.href = res.body.payurl;
}else{
this.feeShow = true;
this.dailogMessage = "支付异常,请稍候再试";
}
},function(err){
console.log(err)
})
},
/*根据不同的操作进行操作*/
refresh(){
if(this.dailogMessage == '您有未处理的订单,请优先处理'){
this.submitable = true;
this.$router.push({path:'/paymentRecord',query:{openid:this.$router.history.current.query.openid,phone:this.$router.history.current.query.phone}})
}
}
}
}



// WEBPACK FOOTER //
// ./src/components/carRentComponents/carPaycoment.vue